import type { Profile } from '@/types'

export type ContactLinkIcon = 'mail' | 'linkedin' | 'instagram' | 'cv'

export type ContactLink = {
    key: ContactLinkIcon
    href: string
    label: string
    cms: string | null
    external: boolean
}

const withProtocol = (value: string): string => /^(https?:)?\/\//i.test(value) || value.startsWith('/')
    ? value
    : `https://${value}`

// Builds the contact and social links from the profile, skipping empty ones.
export const getContactLinks = (profile: Profile): ContactLink[] => {
    const links: ContactLink[] = []
    const email = profile.email?.trim()
    const linkedin = profile.linkedin_url?.trim()
    const instagram = profile.instagram_url?.trim()
    const cv = profile.cv_file?.trim()

    if (email) {
        links.push({
            key: 'mail',
            href: `mailto:${email}`,
            label: profile.email ?? email,
            cms: `profile:${profile.id}:email`,
            external: false
        })
    }

    if (linkedin) {
        links.push({ key: 'linkedin', href: withProtocol(linkedin), label: 'LinkedIn', cms: null, external: true })
    }

    if (instagram) {
        links.push({ key: 'instagram', href: withProtocol(instagram), label: 'Instagram', cms: null, external: true })
    }

    if (cv) {
        links.push({ key: 'cv', href: withProtocol(cv), label: 'Download my CV', cms: null, external: true })
    }

    return links
}
